module.exports = __webpack_public_path__ + "static/img/b1.b0c8bb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial2/b1.jpg
// module id = Vs17
// module chunks = 14